import React, { useState } from 'react';
import { Text, View } from 'react-native';
import Loader from '../Loader/loader';
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';


const FetchingDataScreen = ({ loaderMessage }) => {
  // const [isLoading, setIsLoading] = useState(true);

  const getStyles = useCssStyle();

  const { t } = useTranslation();

  return (
      <View style={getStyles(['overlayContainer'])}>
        <Text style={getStyles(['overlayContainer_message'])}>{loaderMessage || t('appLoader.loaderMessage')}</Text>
        <Loader style={getStyles(['overlayContainer_loader'])} />
      </View>
  );
};

export default FetchingDataScreen;
